export type VorgangPickerScope = "all" | "contact";

/** Im Termin bleibt die Vorschlagsliste eng; eine bewusste Suche bleibt global. */
export function pickerScope(nurKontaktOhneSuche: boolean, query: string): VorgangPickerScope {
    return nurKontaktOhneSuche && query.trim() === "" ? "contact" : "all";
}
